module.exports = __webpack_public_path__ + "img/x.6588e8fd.svg";